import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerTransactionComponent } from './dealer-transaction.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';

const routes: Routes = [
  { path: '', component: DealerTransactionComponent,
    children: [
      //{ path: 'quotes', component: DealerAccountComponent },
      //{ path: 'pending', component: DealerAccountComponent },
      //{ path: 'completed', component: DealerAccountComponent },

      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerTransactionRoutingModule { }
